<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <button
                        @click="preValidateForm()"
                        class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        Registrar
                    </button>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Registro de QR Code PIX
                </h2>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Para quem
                        </template>

                        <template #description>
                            Informe a pessoa que fará o pagamento do PIX.
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-5">
                                <jet-label for="bank" value="Pagador"/>
                                <jet-auto-complete
                                    id="contact" class="mt-1 block w-full"
                                    :endpoint="'contacts'"
                                    :auto-load="true"
                                    v-model="form.selected_contact"/>
                                <jet-input-error :message="form.error('account.contact')" class="mt-2"/>
                                <jet-input-error :message="formErrors.contact" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-1">
                                <inertia-link
                                    class="w-full inline-flex items-center mt-6 px-4 py-3 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                                    :href="route('contact.create')">
                                    <div class="w-full text-center">Novo</div>
                                </inertia-link>
                            </div>

                            <div class="col-span-6 sm:col-span-6" v-show="form.selected_contact.federal_document">
                                <div>
                                    <span class="text-xs">Documento: </span><br/>
                                    {{ form.selected_contact.federal_document }}
                                </div>
                                <div v-if="form.selected_contact.address.street">
                                    <span class="text-xs">Endereço: </span><br/>
                                    {{ form.selected_contact.address.street }}, {{
                                        form.selected_contact.address.number
                                    }} - {{ form.selected_contact.address.complement }} -
                                    {{ form.selected_contact.address.neighborhood }}<br/>
                                    {{ form.selected_contact.address.zip_code }} -
                                    {{ form.selected_contact.address.city }} - {{ form.selected_contact.address.state }}
                                </div>
                                <div v-if="!form.selected_contact.address.street">
                                    O endereço do pagador é obrigatório para geração de cobrança PIX.<br/>
                                    Clique em editar e atualize o cadastro.
                                </div>
                                <jet-input-error :message="formErrors.address" class="mt-2"/>
                                <div class="text-right">
                                    <inertia-link
                                        class="inline-flex mt-3 text-xs items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                                        :href="`/contact/${form.selected_contact.id}`">Editar
                                    </inertia-link>
                                </div>
                            </div>

                        </template>
                    </jet-form-section>
                </template>

                <jet-section-border/>


                <template>
                    <jet-form-section>
                        <template #title>
                            Pagamento
                        </template>

                        <template #description>
                            Informe o valor e as taxas do boleto
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="amount" value="Valor"/>
                                <jet-decimal id="amount" type="text" class="mt-1 block w-full text-lg"
                                             v-model="form.amount"/>
                                <jet-input-error :message="form.error('amount')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-4"></div>
                            <!-- datas -->
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="custom_number" value="Número Documento"/>
                                <jet-input
                                    id="custom_number" class="mt-1 block w-full"
                                    v-model="form.custom_number"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="due_date" value="Vencimento"/>
                                <jet-date-picker
                                    id="due_date" class="mt-1 block w-full"
                                    :disabled-dates="{to: moment().subtract(1, 'day').toDate()}"
                                    v-model="form.due_date"/>
                                <jet-input-error :message="formErrors.due_date" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="limit_date" value="Data limite"/>
                                <jet-date-picker
                                    id="limit_date" class="mt-1 block w-full"
                                    :disabled-dates="{to: form.due_date || null}"
                                    v-model="form.limit_date"/>
                                <jet-input-error :message="formErrors.limit_date" class="mt-2"/>
                            </div>

                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="interest_type" value="Tipo de juros"/>
                                <jet-auto-complete
                                    id="interest_type" class="mt-1 block w-full"
                                    :options-list="interestTypes"
                                    v-model="form.interest_type"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="interest_amount" value="Juros"/>
                                <jet-decimal id="interest_amount" type="text" class="mt-1 block w-full text-lg"
                                             :disabled="form.interest_type.id === '5'"
                                             v-model="form.interest_amount"/>
                                <jet-input-error :message="form.error('interest_amount')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="interest_date" value="A partir de"/>
                                <jet-date-picker v-model="form.interest_date"
                                                 :disabled="form.interest_type.id === '5'"
                                                 :disabled-dates="{to: moment(form.due_date).add(1, 'day').toDate() || null}"
                                                 class="mt-1"/>
                                <jet-input-error :message="form.error('interest_date')" class="mt-2"/>
                            </div>
                            <!-- multa -->
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="fine_type" value="Tipo de multas"/>
                                <jet-auto-complete
                                    id="fine_type" class="mt-1 block w-full"
                                    :options-list="fineTypes"
                                    v-model="form.fine_type"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="fine_amount" value="Multa"/>
                                <jet-decimal id="fine_amount" type="text" class="mt-1 block w-full text-lg"
                                             :disabled="form.fine_type.id === '3'"
                                             v-model="form.fine_amount"/>
                                <jet-input-error :message="form.error('fine_amount')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="fine_date" value="A partir de"/>
                                <jet-date-picker v-model="form.fine_date"
                                                 :disabled="form.fine_type.id === '3'"
                                                 :disabled-dates="{to: moment(form.due_date).add(1, 'day').toDate() || null}"
                                                 class="mt-1"/>
                                <jet-input-error :message="form.error('fine_date')" class="mt-2"/>
                            </div>
                            <!-- desconto -->
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="discount_type" value="Tipo de descontos"/>
                                <jet-auto-complete
                                    id="discount_type" class="mt-1 block w-full"
                                    :options-list="discountTypes"
                                    v-model="form.discount_type"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="discount_amount" value="Desconto"/>
                                <jet-decimal id="discount_amount" type="text" class="mt-1 block w-full text-lg"
                                             :disabled="form.discount_type.id === '0'"
                                             v-model="form.discount_amount"/>
                                <jet-input-error :message="form.error('discount_amount')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="discount_date" value="Até o dia"/>
                                <jet-date-picker v-model="form.discount_date"
                                                 :disabled="form.discount_type.id === '0'"
                                                 :disabled-dates="{from: moment(form.due_date).subtract(1, 'day').toDate() || null}"
                                                 class="mt-1"/>
                                <jet-input-error :message="form.error('discount_date')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>
                </template>

                <jet-section-border/>

            </div>

            <jet-confirmation-modal :show="reviewBoleto" @close="reviewBoleto=false">
                <template #title>
                    Confirme os dados
                </template>

                <template #content>

                    <template>
                        <jet-section-border/>
                        <jet-form-section>
                            <template #title>
                                Dados do boleto
                            </template>

                            <template #description>
                                Verifique se as informações estão corretas antes de finalizar o registro
                            </template>

                            <template #form class=" gap-0">
                                <div class="col-span-6 sm:col-span-6">
                                    <table class="w-full">
                                        <template>
                                            <tr>
                                                <td class="px-2 py-2 text-sm">
                                                    <span class="text-3xl font-extrabold">
                                                        R$ {{ form.amount }}</span><br/>
                                                    Para <span class="font-bold">{{ form.selected_contact.name }}</span>
                                                    <jet-input-error :message="form.error('amount')" class="mt-2"/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="px-2 py-2 text-sm">
                                                    {{ form.selected_contact.address.street }}, {{
                                                        form.selected_contact.address.number
                                                    }} - {{ form.selected_contact.address.complement }} -
                                                    {{ form.selected_contact.address.neighborhood }}<br/>
                                                    {{ form.selected_contact.address.zip_code }} -
                                                    {{ form.selected_contact.address.city }} -
                                                    {{ form.selected_contact.address.state }}
                                                </td>
                                            </tr>

                                        </template>
                                    </table>
                                </div>

                            </template>
                        </jet-form-section>
                        <jet-section-border/>
                        <jet-form-section>
                            <template #title>
                                Autenticação
                            </template>

                            <template #description>
                                Informe o código de autorização para autenticar sua solicitação
                            </template>

                            <template #form>
                                <div class="col-span-6 sm:col-span-6">
                                    <jet-label for="google_code" value="Código de Autorização"/>
                                    <jet-input id="google_code" type="number" class="mt-1 block w-full"
                                               v-model="form.google_code"/>
                                    <jet-input-error :message="form.error('google_code')" class="mt-2"/>
                                </div>
                            </template>
                        </jet-form-section>
                    </template>


                </template>

                <template #footer>
                    <jet-secondary-button @click.native="reviewBoleto = false">
                        Agora não
                    </jet-secondary-button>
                    <!-- :disabled="form.processing" -->
                    <jet-ok-button class="ml-2"
                                   @click.native="register"
                                   :class="{ 'opacity-25': form.processing }">
                        Confirmar
                    </jet-ok-button>
                </template>
            </jet-confirmation-modal>

        </div>

    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetInput from "../../Jetstream/Input";
import JetTextarea from "../../Jetstream/Textarea";
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetFetchDoc from "../../Jetstream/FetchDoc";
import JetDatePicker from "../../Jetstream/DatePicker";
import JetRadio from "../../Jetstream/Radio";
import JetDecimal from "../../Jetstream/Decimal";
import JetConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import Flash from "../../Helpers/Flash"
import moment from 'moment';

export default {
    props: ['goal_list', 'errors', 'boleto'],
    methods: {
        register() {
            const endpoint = this.boleto ? `/boleto/${this.boleto.id}` : '/boleto';
            this.form._method = this.boleto ? 'PUT' : 'POST';
            this.form.post(endpoint, {
                resetOnSuccess: true,
                onError: (e) => {
                    this.form.processing = false;
                }
            });
        },
        customOption: (option) => {
            let bankName = option.bank.code === '274' ? `Conta ${$page.props.white_label.data.short_name}` : option.bank.name;
            return `${option.name} | <span class="text-xs">${bankName} | ${option.number}-${option.digit}</span>`;
        },
        preValidateForm() {
            let hasErrors = false;

            this.formErrors = {
                due_date: null,
                limit_date: null,
                amount: '0,00',
                selected_contact: {
                    name: null,
                    address: {
                        street: null,
                        number: null,
                        complement: null,
                        neighborhood: null,
                        city: null,
                        state: null,
                        zip_code: null,
                    }
                }
            }

            if (!this.form.selected_contact.id) {
                this.formErrors.contact = 'Esse campo é obrigatório';
                hasErrors = true;
            }
            if (this.form.selected_contact.id && !this.form.selected_contact.address.street) {
                this.formErrors.address = 'Você deve informar um endereço válido';
                hasErrors = true;
            }
            if (!this.form.due_date) {
                this.formErrors.due_date = 'Esse campo é obrigatório';
                hasErrors = true;
            }
            if (!this.form.limit_date) {
                this.formErrors.limit_date = 'Esse campo é obrigatório';
                hasErrors = true;
            }
            if (!hasErrors) {
                this.reviewBoleto = true;
            }
            return true;
        }
    },
    data() {
        return {
            moment: moment,
            flashIsVisible: true,
            reviewBoleto: false,
            moreDetails: false,
            formErrors: {
                due_date: null,
                limit_date: null,
                amount: '0,00',
                selected_contact: {
                    name: null,
                    address: {
                        street: null,
                        number: null,
                        complement: null,
                        neighborhood: null,
                        city: null,
                        state: null,
                        zip_code: null,
                    }
                }
            },
            cancelTransfer: null,
            form: this.$inertia.form({
                selected_contact: {
                    name: null,
                    address: {
                        street: null,
                        number: null,
                        complement: null,
                        neighborhood: null,
                        city: null,
                        state: null,
                        zip_code: null,
                    }
                },
                amount: null,
                google_code: null,
                description: null,
                due_date: null,
                limit_date: null,
                interest_type: {id: '5', name: 'Isento'},
                interest_amount: null,
                interest_date: null,
                fine_type: {id: '3', name: 'Isenta'},
                fine_amount: null,
                fine_date: null,
                discount_type: {id: '0', name: 'Isento'},
                discount_amount: null,
                discount_date: null,
                custom_number: null,
                ...this.boleto

            }, {
                resetOnSuccess: false,
            }),
            interestTypes: [
                {id: '3', name: 'Percentual ao mês'},
                {id: '5', name: 'Isento'},
            ],
            fineTypes: [
                {id: '2', name: 'Percentual'},
                {id: '3', name: 'Isenta'},
            ],
            discountTypes: [
                {id: '0', name: 'Isento'},
                {id: '1', name: 'Valor fixo'},
                {id: '2', name: 'Percentual'},
                {id: '3', name: 'Valor por antecipação'},
                {id: '5', name: 'Percentual por antecipação'},
            ],
        }
    },
    components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetRadio,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetDatePicker,
        JetDecimal,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton
    },
}
</script>
